import { Grid } from '@material-ui/core';
import React, { memo, useEffect } from 'react';
import affiliateService from 'v2/services/affiliate';

import Details from './Details';
import Filter from './Filter';
import Table from './Table';

const Affiliate = () => {
  useEffect(() => {
    return () => affiliateService.cleanFilter();
  }, []);

  return (
    <>
      <Grid id='my-affiliates' container justify='space-between' alignItems='flex-start'>
        <div className='my-title'>
          <h1>Meus Afiliados</h1>
          <p>Gerencie suas solicitações, afiliados aprovados e reprovados.</p>
        </div>
      </Grid>
      <div className='m32' />
      <Filter />
      <div className='m16' />
      <Details />
      <Table />
    </>
  );
};

export default memo(Affiliate);
